<template>
<div class="chapter">
<div class="inner_page">
<div style="text-indent:0;text-align:center;margin-right:auto;margin-left:auto;width:99%;page-break-before:auto;page-break-inside:avoid;page-break-after:always;"><div style="margin-left:auto;margin-right:auto;text-align:center;text-indent:0;width:75%;"><p style="display:inline-block;text-indent:0;width:100%;"><img alt="[Image]" class="art" id="GrowingUpGronk_004_1" src="images/GrowingUpGronk_004_1.jpg" style="width:99%;"/></p></div><br/><span class="subcaption">The Gronkowski boys exhibited a love of sports from an early age. Top, from left, Dan, Chris, and Gordie. Seated, from left, Rob and Goose.</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?4f144017